import { render, staticRenderFns } from "./Jy.vue?vue&type=template&id=050587d0&scoped=true"
import script from "./Jy.vue?vue&type=script&lang=js"
export * from "./Jy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050587d0",
  null
  
)

export default component.exports